import { z } from "zod";

import { FIELD_TYPE } from "@/features/forms/models";
import { FUNNEL_PHASE } from "./constants";

const funnelIntakeOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
  icon: z.string().nullable(),
  exclusive: z.boolean(),
  emphasized: z.boolean(),
  disqualifies: z.boolean(),
  blockingMessage: z.string().nullable(),
  get followUps() {
    return z.array(funnelIntakeQuestionSchema);
  },
});

const funnelIntakeQuestionSchema = z.object({
  key: z.string(),
  label: z.string().nullable(),
  input: z.enum(FIELD_TYPE),
  required: z.boolean(),
  placeholder: z.string().nullable(),
  skippable: z.boolean(),
  options: z.array(funnelIntakeOptionSchema),
  visibleWhen: z
    .object({
      questionKey: z.string(),
      values: z.array(z.string()),
    })
    .nullable(),
});

const funnelIntakeStepSchema = z.object({
  slug: z.string(),
  order: z.number(),
  phase: z.enum(FUNNEL_PHASE),
  title: z.string(),
  description: z.string().nullable(),
  footerNote: z.string().nullable(),
  questions: z.array(funnelIntakeQuestionSchema),
});

export const funnelIntakeSchema = z.object({
  formType: z.string(),
  steps: z.array(funnelIntakeStepSchema),
});
